import { graphql, useStaticQuery } from "gatsby"

export const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          image
          siteUrl
          twitterUsername
          author
        }
      }
      datoCmsCompany {
        title
        subtitle
        phone
        address
        email
        instagramPageHandle
        facebookPageHandle
        googleBusinessProfileUrl
        workDays {
          id
          weekday
          timeFrom
          timeTo
          isWeekend
        }
        menuItems {
          id
          isActive
          title
          to
        }
        mapImage {
          gatsbyImageData(placeholder: BLURRED, width: 600, layout: CONSTRAINED)
        }
        certificates {
          id
          title
          image {
            gatsbyImageData(
              placeholder: BLURRED
              width: 300
              height: 200
              layout: FIXED
            )
          }
        }
      }
    }
  `)

  return data
}
